export default "__VITE_ASSET__BNnMVjsV__"